import { render } from "./CompanySuperAdmin.vue?vue&type=template&id=00a32b4f"
import script from "./CompanySuperAdmin.vue?vue&type=script&lang=js"
export * from "./CompanySuperAdmin.vue?vue&type=script&lang=js"

import "./CompanySuperAdmin.vue?vue&type=style&index=0&id=00a32b4f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__